import type { TablePagination } from '@sparklayer-io/spark-dash-ui/components/ui/table/types';
import { Badge, Button, Table, Text } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';
import type { Customer } from '../types/customer';
import { RoleBadge } from './customer-role-badge';

export type CustomersTableProps = {
  customers: Customer[];
  caption?: string;
  pagination?: TablePagination;
};

export function CustomersTable({
  customers,
  caption,
  pagination,
}: CustomersTableProps): JSX.Element {
  return (
    <Table
      caption={caption ?? t('features:customers.components.customers_table.default_caption')}
      headings={[
        t('features:customers.components.customers_table.headings.name'),
        t('features:customers.components.customers_table.headings.email'),
        t('features:customers.components.customers_table.headings.role'),
        t('features:customers.components.customers_table.headings.group'),
      ]}
      pagination={pagination}
    >
      {customers.map((customer, index) => (
        <CustomersTableRow key={customer.id} customer={customer} index={index} />
      ))}
    </Table>
  );
}

function CustomersTableRow({ customer, index }: { customer: Customer; index: number }) {
  const { navigationHandler } = useHandlers();
  const pageSlug = navigationHandler.path().split('/').filter(Boolean).at(-1);

  return (
    <Table.Row key={customer.id} index={index} id={customer.id}>
      <Table.Cell>
        <Text>{`${customer.first_name} ${customer.last_name}`}</Text>
      </Table.Cell>
      <Table.Cell>
        <Text>{customer.email}</Text>
      </Table.Cell>
      <Table.Cell>
        <RoleBadge role={customer.role_object} />
      </Table.Cell>
      <Table.Cell>
        <Badge variant="green">{customer.group}</Badge>
      </Table.Cell>
      <Table.Cell sticky>
        <Button
          variant="secondary"
          onClick={() =>
            navigationHandler.navigate(`/v2/customers/${pageSlug}/details/${customer.id}`)
          }
        >
          {t('buttons:view')}
        </Button>
      </Table.Cell>
    </Table.Row>
  );
}
